// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_enquiry,
  add_enquiry,
  update_enquiry,
  delete_enquiry,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  enquirys: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
   enquiry_type:"",
   message:""
  },
  filterData: {
    enquiry_type:"",
    status:""
   }
};


// Async Thunks for API Calls
export const fetchenquiry = createAsyncThunk(
  "enquiry/fetchenquiry",
  async (
    { page, page_size, school_id,enquiry_type,status, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_enquiry(
        page,
        page_size,
        school_id,
        enquiry_type,status,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createenquiry = createAsyncThunk(
  "enquiry/createenquiry",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_enquiry(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateenquiry = createAsyncThunk(
  "enquiry/updateenquiry",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_enquiry(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteenquiry = createAsyncThunk(
  "enquiry/deleteenquiry",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_enquiry({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const enquirySlice = createSlice({
  name: "enquirys",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      const { id, enquiry_type,message } = action.payload;
      state.formData = { id, enquiry_type,message  };
    },
    resetFormData(state) {
      state.formData = {
        enquiry_type:"",
   message:""
      };
    },
    setenquiry(state, action) {
      state.enquirys = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchenquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchenquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.enquirys = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchenquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createenquiry.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createenquiry.fulfilled, (state, action) => {
        state.addLoading = false;
        state.enquirys = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createenquiry.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateenquiry.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateenquiry.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateenquiry.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteenquiry.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteenquiry.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteenquiry.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setenquiry,
  setActivePage,
  updateFilterData,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = enquirySlice.actions;
export default enquirySlice.reducer;
